import './App.css';
import Login from "./screens/Login/Login";
import OffersList from "./screens/Offers/OffersList";
import OfferForm from "./screens/Offers/OfferForm";
import UserForm from "./screens/Users/UserForm";
import UsersList from "./screens/Users/UsersList";

import AdminUsersList from "./screens/AdminUsers/List";
import AdminUserForm from "./screens/AdminUsers/Form";

import Privacy from "./screens/Public/Privacy";
import Terms from "./screens/Public/Terms";

import {
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";

const App = () => {
  let routes = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/terms", element: <Terms /> },
    { path: "/privacy", element: <Privacy /> },
    { path: "/admin", element: <OffersList /> },
    { path: "/admin/users", element: <UsersList /> },
    { path: "/admin/users/:id", element: <UserForm /> },
    { path: "/admin/offers", element: <OffersList /> },
    { path: "/admin/offers/:id", element: <OfferForm /> },
    { path: "/admin/offers/add", element: <OfferForm /> },

    { path: "/admin/admin-users", element: <AdminUsersList /> },
    { path: "/admin/admin-users/new", element: <AdminUserForm /> },
    { path: "/admin/admin-users/:id", element: <AdminUserForm /> },    
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWrapper;